<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2>
					<!--<button @click.prevent="goBack">
						<i class="fa fa-arrow-right"></i>
					</button>-->
					نمایش موقعیت ها در نقشه
					<!--<button data-menu="HelpMenu" class="position-static"><i class="fa fa-question-circle helpIco"></i></button>-->
				</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage">
					<i class="font-16 fa fa-redo"></i>
				</button>
				<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="100">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
			</div>
			<!--<div class="card card-style mb-2">
				<div class="p-3 d-flex">
					<button id="filterBtn" type="button" class="btn btn-xs rounded-m brand-bg-color ml-1" data-toggle="modal" data-target="#searchModal" style="max-height:31px!important">
						<i class="fa fa-filter text-white"></i>
					</button>
					<div class="filter-row-scrollable">

					</div>
				</div>
			</div>-->
			<div class="card card-style mb-2 overflow-visible">
				<div class="p-3">
					<div class="btn-group btn-group-sm w-100" role="group" aria-label="Button group with nested dropdown">
						<v-select class="w-100" dir="rtl" label="title" placeholder="انتخاب کاربر" :filterable="localUserListList.length > 10" :searchable="localUserListList.length > 10" :options="localUserListList" :reduce="(p) => p.userId" v-model="userId" @option:selected="GetDateList">
							<template slot="option">
								<div class="d-center">
									{{ option.title }}
								</div>
							</template>
						</v-select>
					</div>
					<!--<div class="filter-row-scrollable">
			<div v-for="item in GetDates" :key="item">
				<div @click="lstFilter(item)" :id="item" class="filterSelectItem filter-scrollable-box" :class="presenceDate==item ? 'selected' : ''">{{ item }}</div>
			</div>
		</div>-->
				</div>
				<div class="px-3 pb-3">
					<div class="btn-group btn-group-sm w-100" role="group" aria-label="Button group with nested dropdown">
						<v-select class="w-100" dir="rtl" label="title" placeholder="تاریخ" :filterable="DateList.length > 10" :searchable="DateList.length > 10" :options="DateList" v-model="presenceDate" @option:selected="GetList">
							<template slot="option">
								<div class="d-center">
									{{ option }}
								</div>
							</template>
						</v-select>
					</div>
				</div>
				</div>
				<div class="card card-style">
					<div class="content mb-0">
						<div class="mb-4">
							<div id="container">
								<div id="mapContainer" @click="handleClickDetailsButton" v-show="showDetailsModal==false"></div>
							</div>
						</div>
						<div v-if="selectedItem != null">
							<p>عنوان : {{ selectedItem.title }}</p>
							<p v-if="selectedItem.description != null">
								توضیحات : {{ selectedItem.description }}
							</p>
							<p v-if="selectedItem.address != null">
								آدرس : {{ selectedItem.address }}
							</p>
						</div>
					</div>
				</div>
			</div>


		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10">
					<i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...
				</div>
			</div>
		</transition>
		<transition name="modal" enter-active-class="animated fadeIn" appear>
			<div v-if="showDetailsModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container">
						<div class="modal-body m-0">
							<slot name="body">
								<edit-user-presence :showInModal="'1'" :selectedUserPrecenceId="selectedItemId" @close="showDetailsModal=false"></edit-user-presence>
							</slot>
						</div>
						<div class="modal-footer py-1 px-2">
							<slot name="footer">
								<button class="btn btn-xxs rounded-s bg-red1-light" @click="showDetailsModal=false">
									<i class="fa fa-times ml-2"></i>
									بستن
								</button>
							</slot>
						</div>
					</div>
				</div>
			</div>
		</transition>
		<Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>

		<div id="searchModal" class="modal fade" role="dialog">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header align-items-center">
						<h4 class="modal-title mt-0">جستجو</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body m-0">
						<!--<div class="mb-3">
							<div class="w-100 search-box rounded-m position-relative">
								<i class="fa fa-search pr-3"></i>
								<input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey">
							</div>
						</div>-->
						<myTeamList txtPlaceholder="کاربران" class="mb-3" @selectUser="selectUser"></myTeamList>

						<v-select class="w-100" dir="rtl" label="p" placeholder="تاریخ" :filterable="GetDates.length > 10" :searchable="GetDates.length > 10" :options="GetDates" :reduce="(p) => p" v-model="presenceDate">
							<template slot="option">
								<div class="d-center">
									{{ option }}
								</div>
							</template>
						</v-select>

						<button type="button" class="btn mt-3 btn-xxs btn-full bg-green1-dark rounded-sm font-900 w-100" data-dismiss="modal" @click="GetList">
							<i class="fa fa-search ml-2"></i>
							جستجو
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import "vue-select/dist/vue-select.css";
	import editUserPresence from '../UserPresence/EditUserPresence.vue';
	import HelpMenu from '../Components/HelpMenu.vue';
	import MyTeamList from '../Components/MyTeamList.vue';
	import "leaflet/dist/leaflet.css";
	import { Geolocation } from "@capacitor/geolocation";
	import L from "leaflet";
	import "leaflet-polylinedecorator";
	const token =
		"pk.eyJ1IjoiZmhrYXplbWkiLCJhIjoiY2s5aGhwb3kxMDAxZTNsbHF2cWk0OXNpaiJ9.XyjH4-d0c05NOcyoZL-2tg";

	import Snap from "snapsvg-cjs";
	import "leaflet.bezier";
	export default {
		components: {
			"edit-user-presence": editUserPresence,
			"Help-Menu": HelpMenu,
			"myTeamList": MyTeamList,
			// LMap,
			// LTileLayer,
			// LPolyline,
			// LMarker,
			// LPopup
		},

		data() {
			return {
				attInProgress: false,
				modified: false,
				showDetailsModal: false,
				mapLocationObject: null,
				url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
				attribution:
					'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
				presenceDate: null,
				page: 1,
				filterId: 0,
				searchKey: "",
				selectedItem: null,
				selectedItemId: 0,
				pageLoaded: false,
				userId: null,
				mapDiv: null,
				DateList: [],
				UserPresenceList: [{ lat: 35.715298, lng: 51.404343 }],
			};
		},
		computed: {
			Loading() {
				return this.$store.getters.GetLoading;
			},
			localUserListList() {
				return this.$store.getters.GetLocalUserListList;
			},
			GetDates() {
				return this.DateList;
			},

			PolyLine() {
				var list = this.UserPresenceList;
				var latLongArr = [];
				if (list != null) {
					console.log(list);
					console.log(list[0]);
					for (let index = 0; index < list.length; index++) {
						var m = list[index].mapLocation.split(",");
						var el = { lat: +m[0], lng: +m[1] };
						latLongArr.push(el);
					}
				}

				return {
					latlngs: latLongArr,
					color: "green",
				};
			},
		},
		created() {
			this.$store.dispatch("GetLocalUserListListFromServerForMap", {
				workGroupId: null,
			});
		},
		async mounted() {
			await this.GetList();
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");

		},
		watch: {
			presenceDate: {
				deep: true,
				async handler(value) {
					//this.GetList();
				}
			}
		},
		methods: {
			selectUser(d) {
				this.userId = d;
				this.GetDateList();
			},
			lstFilter(data) {
				this.presenceDate = data;
				var elements = document.getElementsByClassName('filterSelectItem');
				for (var i = 0; i < elements.length; i++) {
					elements[i].classList.remove('selected');
				}
				document.getElementById(data).classList.add('selected');
				this.GetList();
			},
			async GetList() {
				if (this.userId == null || this.presenceDate == null) {
					document.getElementById('mapContainer').innerHTML = "<div class='text-center'><i class='fa fa-exclamation-triangle text-warning fa-3x'></i></div><p class='text-center py-3'>لطفا کاربر و تاریخ را وارد کنید.</p>";
					return;
				}
				var uId = "";
				var dt = "";
				if (this.userId != null) {
					uId = this.userId;
				}
				if (this.presenceDate != null) {
					dt = this.presenceDate;
				}
				this.$http.get("UserPresence/GetUserPresenceListForMap?date=" + dt + "&userId=" + uId)
					.then((data) => {
						if (data.data.length == 0) {
							document.getElementById('mapContainer').innerHTML = "<div class='text-center'><i class='fa fa-exclamation-triangle text-danger fa-3x'></i></div><p class='text-center py-3'>موقعیت کاربر در این تاریخ ثبت نشده است.</p>";
							return;
						}
						this.UserPresenceList = data.data;
						if (this.mapDiv == null) {
							this.intiateMap();
						}
						this.setupLeafletMap();
					});
			},

			GetDateList() {
				var uId = "";
				if (this.userId != null) {
					uId = this.userId;
				}
				this.$http.get("UserPresence/GetDateListForUser?userId=" + uId)
					.then((data) => {
						this.DateList = data.data;
						if (data.data.length == 0) {
							document.getElementById('mapContainer').innerHTML = "<div class='text-center'><i class='fa fa-exclamation-triangle text-danger fa-3x'></i></div><p class='text-center py-3'>موقعیتی برای این کاربر ثبت نشده است.</p>";
							return;
						}
						this.GetList();
					});
			},
			CreateUserPresence() {
				this.v$.$touch(); //it will validate all fields
				if (!this.v$.$invalid) {
					//invalid, becomes true when a validations return false
					this.modified = false;
					this.$store.dispatch("CreateUserPresence", this.userPresenceModel);
					this.modified = false;
				}
			},
			async intiateMap() {
				console.log("dsd");
			},
			async setupLeafletMap() {

				if (this.mapDiv != null) {
					this.mapDiv.remove();
				}

				document.getElementById('mapContainer').innerHTML = "";

				this.mapDiv = L.map("mapContainer").setView(
					this.PolyLine.latlngs[0],
					15
				);

				//this.mapDiv.options.maxZoom = 19;

				L.tileLayer(
					`https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png`,
					{
						//maxZoom: 22,
						maxNativeZoom: 19,
						accessToken: `${token}`,
					}
				).addTo(this.mapDiv);


				var mapDiv = this.mapDiv;
				for (var i in mapDiv._layers) {
					if (mapDiv._layers[i]._path != undefined) {
						try {
							mapDiv.removeLayer(mapDiv._layers[i]);
						} catch (e) {
							console.log("problem with " + e + mapDiv._layers[i]);
						}
					}
				}
				var polylinePoints = this.PolyLine.latlngs;
				// var polyline = L.polyline(polylinePoints).addTo(mapDiv);
				var options = {
					color: 'rgb(145, 146, 150)',
					fillColor: 'rgb(145, 146, 150)',
					dashArray: 8,
					opacity: 1,
					weight: '2',
					iconTravelLength: 0.5, //How far icon should go. 0.5 = 50%
					iconMaxWidth: 30,
					iconMaxHeight: 30,
					fullAnimatedTime: 5000,// animation time in ms
					easeOutPiece: 4, // animation easy ou time in ms
					easeOutTime: 2500, // animation easy ou time in ms
				};
				L.bezier({
					path: [
						polylinePoints,
					],

					icon: {
						path: "plane.png"
					}
				}, options).addTo(mapDiv);

				// var decorator = L.polylineDecorator(polyline, {
				//   patterns: [
				//     // defines a pattern of 10px-wide dashes, repeated every 20px on the line
				//     {
				//       offset: 0,
				//       repeat: 20,
				//       symbol: L.Symbol.arrowHead({
				//         pixelSize: 6,
				//         polygon: true,
				//         pathOptions: { stroke: true },
				//       }),
				//     },
				//   ],
				// }).addTo(mapDiv);


				mapDiv.fitBounds(polylinePoints);
				for (let index = 0; index < this.PolyLine.latlngs.length; index++) {
					var cloudIcon = L.divIcon({
						html: index + 1,
						className: "my-custom-icons",
						iconSize: [24, 24],
						iconAnchor: [24 / 2, 24],
					});
					var marker = L.marker(this.PolyLine.latlngs[index], { icon: cloudIcon }).addTo(
						mapDiv
					);
					var poupText = "<span class='spanDetails'><i class='fa fa-clock color-green2-dark ml-2'></i><b>ساعت: </b>" + this.UserPresenceList[index].createDateTime + "</span><br/><b class='spanDetails'><i class='fa fa-check-square color-green2-light ml-2'></i>" + this.UserPresenceList[index].title + "</b>";
					if (this.UserPresenceList[index].address != null) {
						poupText = poupText + "<br/><span class='spanDetails mb-2'><i class='fa fa-map-marker-alt color-green1-dark ml-2'></i><b>آدرس: </b>" + this.UserPresenceList[index].address + "</span>"
					}
					if (this.UserPresenceList[index].description != null && this.UserPresenceList[index].description.length > 0) {
						poupText = poupText + "<br/><span class='spanDetails mb-2'><i class='fa fa-edit color-green1-light ml-2'></i><b>توضیحات: </b>" + this.UserPresenceList[index].description + "</span>"
					}
					poupText = poupText + "<br/><button class='item-details btn btn-xxs mt-2 btn-full bg-green1-dark rounded-sm font-900 w-100' data-itemid='" + this.UserPresenceList[index].userPresenceId + "'><i class='fa fa-search ml-2'></i>جزییات بیشتر</button>"
					marker.bindPopup(poupText, {
						closeButton: false,
						className: "popUpDiv",
						maxWidth: 220,
					});
				}


			},
			checkLocation() {
				window.plugins.locationAccuracy.canRequest(function (canRequest) {
					if (canRequest) {
						window.plugins.locationAccuracy.request(
							function (success) {
								console.log(
									"Successfully requested accuracy: " + success.message
								);
							},
							function (error) {
								console.error(
									"Accuracy request failed: error code=" +
									error.code +
									"; error message=" +
									error.message
								);
								if (
									error.code !==
									window.plugins.locationAccuracy.ERROR_USER_DISAGREED
								) {
									if (
										window.confirm(
											"Failed to automatically set Location Mode to 'High Accuracy'. Would you like to switch to the Location Settings page and do this manually?"
										)
									) {
										window.plugins.diagnostic.switchToLocationSettings();
									}
								}
							},
							window.plugins.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY
						);
					} else {
						// request location permission and try again
					}
				});
			},

			getServerDateTime() {
				this.$http.get("Task/GetServerDateTime").then((data) => {
					this.userPresenceModel.presenceDate = data.data.split("_")[0];
					this.userPresenceModel.createDateTime = data.data.replace("_", " ");
				});
			},
			async getCurrentPosition() {
				try {
					const coordinates = await Geolocation.getCurrentPosition({
						enableHighAccuracy: true,
					});
					console.log(coordinates.coords.latitude);
				} catch (ex) {
					console.log(ex);
					this.showErrorMessage(
						"خطا در دریافت موقعیت مکانی. لطفا از روشن بودن Location دستگاه خود مطمئن شوید و مجددا تلاش کنید."
					);
				}
			},
			handleClickDetailsButton(e) {
				const elt = e.target.closest(".item-details");
				if (elt) {
					this.selectedItemId = elt.dataset.itemid;
					this.showDetailsModal = true;
				}
			},

			setTitle() {
				if (this.userPresenceModel.userPresenceTypeId == 1) {
					this.userPresenceModel.title = "ورود";
				} else if (this.userPresenceModel.userPresenceTypeId == 2) {
					this.userPresenceModel.title = "خروج";
				} else {
					this.userPresenceModel.title = "";
				}
			},
			showLocationDetails(obj) {
				this.selectedItem = obj;
			},
			pauseVid(id) {
				console.log(id);
				if (id != null) {
					console.log("pause");
					var vid = document.getElementById(id);
					vid.pause();
				}
			},
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
		},


	};
</script>
<style scoped>
	#mapContainer {
		width: 100%;
		height: 400px;
		font-family: 'IRANSansWeb-FaNum' !important;
	}

		#mapContainer > > > .my-custom-icons {
			background-color: rgb(72, 0, 255);
			border-radius: 50%;
			padding: 5px;
			text-align: center;
			color: azure;
			font-weight: bolder;
		}

	.arrow-icon {
		width: 14px;
		height: 14px;
	}

		.arrow-icon > div {
			margin-left: -1px;
			margin-top: -3px;
			transform-origin: center center;
		}

	.spanDetails {
		float: right !important;
		direction: rtl !important;
	}

	.item-details {
		width: 80px;
		height: 50px;
	}

	.popUpDiv .leaflet-popup-content-wrapper {
		background: white !important;
		box-shadow: 0 3px 14px rgba(0,0,0,0.4) !important;
		border-radius: 0.3em;
		direction: rtl !important;
		display: flex;
		justify-content: center;
	}

	.popUpDiv {
		background: white !important;
		box-shadow: 0 3px 14px rgba(0,0,0,0.4) !important;
		border-radius: 0.3em;
		direction: rtl !important;
	}
</style>